<template>
  <div class="">
    <div class="common-title">贸易列表</div>
    <a-table
      size="middle"
      :columns="columns"
      :row-key="record => record.id"
      :data-source="tableDataInv"
      :pagination="pagination"
      @change="handleTableChange"
      :loading="loading"
      bordered
      :locale="{ emptyText: '暂无数据' }"
      :row-selection="tableSelect"
      :scroll="{}"
    >
      <template slot="invoiceType" slot-scope="text">
        {{ text | invoiceTypeFilter }}
      </template>
      <template slot="invoiceNumber" slot-scope="text, record">
        <a @click="toInvoiceInfo(record)">{{ text }}</a>
      </template>
      <template slot="billTime" slot-scope="text">
        {{ text | dateFormat("YYYY-mm-dd") }}
      </template>
      <template slot="invoiceAmountWithVat" slot-scope="text">
        {{ text | splitK }}
      </template>
      <template slot="contractNo" slot-scope="text, record">
        <a v-if="text" @click="contractInfoOpen(record)">{{ text }}</a>
        <span v-else>--</span>
      </template>
      <template slot="otherFile" slot-scope="text, record">
        <a v-if="record.uploaded" @click="toDeliveryCreate(record)">查看</a>
        <span v-else>--</span>
      </template>
    </a-table>

    <!-- 查看弹窗 -->
    <invoiceInfo ref="invoiceInfo" :readonly="true" :info.sync="curRow" />
    <!-- 查看合同 -->
    <contractDialog
      title="匹配合同详情"
      ref="contractInfo"
      :readonly="true"
      :info.sync="curRow"
    />
    <!-- 相关附件 -->
    <relatedFileDialog ref="relatedFileDialog" />
  </div>
</template>

<script>
import { invoiceList } from "@/api/payable.js";
import { mapActions, mapGetters } from "vuex";
import invoiceInfo from "@/pages/bill-manage/receivable/invoice-info-dialog";
import contractDialog from "@/pages/bill-manage/receivable/contract-info-dialog";
import relatedFileDialog from "@/pages/bill-manage/receivable/related-file-dialog";
export default {
  props: {
    params: {
      type: [Array, Object]
    }
  },
  components: {
    invoiceInfo,
    contractDialog,
    relatedFileDialog
  },
  data() {
    return {
      goldInfo: {},
      tableData: [],
      formData: {},
      feeData: {},
      tableDataInv: [],
      columns: [
        {
          title: "买方名称",
          dataIndex: "buryName",
          width: 140,
          ellipsis: true
        },
        {
          title: "发票类型",
          dataIndex: "invoiceType",
          scopedSlots: { customRender: "invoiceType" },
          width: 90
        },
        {
          title: "发票号码",
          dataIndex: "invoiceNumber",
          scopedSlots: { customRender: "invoiceNumber" },
          width: 120
        },
        {
          title: "开票日期",
          dataIndex: "billTime",
          scopedSlots: { customRender: "billTime" },
          width: 120
        },
        {
          title: "含税金额(元)",
          dataIndex: "invoiceAmountWithVat",
          scopedSlots: { customRender: "invoiceAmountWithVat" },
          width: 120
        },
        {
          title: "合同编号",
          dataIndex: "contractNo",
          scopedSlots: { customRender: "contractNo" },
          width: 100
        },
        {
          title: "相关附件",
          dataIndex: "otherFile",
          ellipsis: true,
          width: 100,
          scopedSlots: { customRender: "otherFile" }
        }
      ],
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
        showTotal: total => {
          return `共 ${total} 条`;
        }
      },
      loading: false,
      selectedRows: [],
      selectedRowKeys: [],
      invoiceTypes: [],
      curRow: null
    };
  },
  computed: {
    ...mapGetters({
      getGoldDetailPrarms: "app/getFinancingDetailPrarms"
    }),
    tableSelect() {
      return {
        type: "checkbox",
        selectedRowKeys: this.selectedRowKeys,
        selectedRows: this.selectedRows,
        onSelectAll: this.onSelectAll,
        onSelect: this.onSelect,
        getCheckboxProps: record => ({
          props: {
            disabled: record.canBeModified == "3" // Column configuration not to be checked
          }
        })
      };
    }
  },
  methods: {
    ...mapActions({
      getDicAsync: "app/getDicAsync"
    }),

    getTableData() {
      const self = this;
      let params = {};
      params = {
        gldId: this.params.info.gldLevel == 1 ? this.params.info.gldId : '',
        useCase: "supplier", //查验类型 核心企业导入-融资-供应商导入应收：receivable-financing-supplier
        resultCode: 1,
        useStatus: this.params.info.gldLevel == 1 ? "LOCKED" : "UNUSED", // 判断勾选的融资母票为一级祺信，使用状态为已锁定的发票记录
        buryOrgCode: this.goldInfo.pyptOrgCode,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      };

      this.loading = true;
      invoiceList(params)
        .then(res => {
          this.pagination.total = res.data.grid.total;
          let list = res.data.grid.list;
          this.tableDataInv = list;
          this.loading = false;
          if(this.tableDataInv.length == 0){
            this.$confirm({
              title: "提示",
              okText: "确认",
              content: "当前尚无可匹配本次融资的贸易资料信息，请在应收单据处进行维护",
              onOk() {
                self.MENUAPI.goToOneTab({
                  path: "bill-manage/receivable"
                });
              },
              onCancel() {
                self.MENUAPI.goToOneTab({
                  path: "circulation/borrow"
                });
              }
            });
          }
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
    //表格排序回调
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.pagination.total = this.pagination.total || 0;
      this.getTableData();
    },
    //表格选择回调
    onSelect(selectedRows, checked) {
      if (checked) {
        this.selectedRowKeys.push(selectedRows.id);
        this.selectedRows.push(selectedRows);
      } else {
        let index = this.selectedRowKeys.indexOf(selectedRows.id);
        this.selectedRowKeys.splice(index, 1);
        this.selectedRows.splice(index, 1);
      }
    },
    onSelectAll(selected, selectedRows, changeRows) {
      if (selected) {
        for (let i = 0; i < selectedRows.length; i++) {
          if (this.selectedRowKeys.indexOf(selectedRows[i].id) == -1) {
            this.selectedRowKeys.push(selectedRows[i].id);
            this.selectedRows.push(selectedRows[i]);
          }
        }
      } else {
        for (let i = 0; i < changeRows.length; i++) {
          let index = this.selectedRowKeys.indexOf(changeRows[i].id);
          if (index > -1) {
            this.selectedRowKeys.splice(index, 1);
            this.selectedRows.splice(index, 1);
          }
        }
      }
    },
    // 计算表格勾选合计
    totalPayable(list) {
      return list.reduce((acc, rec) => {
        return acc + (+rec["invoiceAmountWithVat"] || 0);
      }, 0);
    },
    initData() {
      if (this.params && this.params.submitParams) {
        this.tableData =
          (this.getGoldDetailPrarms.requestData &&
            this.getGoldDetailPrarms.requestData.list) ||
          [];
        this.formData =
          (this.getGoldDetailPrarms.requestData &&
            this.getGoldDetailPrarms.requestData.map) ||
          {};
        this.feeData =
          (this.getGoldDetailPrarms && this.getGoldDetailPrarms.feeData) || {};
        this.goldInfo = this.params.info || {};

        this.getTableData();
        console.log("from step1 ", this.params);
      }
    },
    // 查询一级祺信的贸易列表
    getTradeByGldLevel() {
      queryGoldTradeBG({
        gldId: this.params.info.gldId,
        gldLevel: this.params.info.gldLevel
      }).then(res => {
        this.importDisabled = res.data.edit;
      });
    },
    check() {
      return new Promise((resolve, reject) => {
        if (this.selectedRows.length == 0) {
          this.$message.error("请选择贸易列表");
          reject("请选择贸易列表");
          return;
        }
        let sum = 0;
        this.selectedRows.forEach(i => {
          sum += +i.invoiceAmountWithVat;
        });
        sum = sum.toFixed(2);
        /**
         * 非上海银行校验发票合计不可小于本次融资金额
         * 非上海银行校验发票合计不可小于本次融资金额
         */
        if (+this.params.info.gldAmt > sum && this.dict.bankListMap[this.params.bankChecked.bank] == 'shanghai') {
          this.$message.error(
            "发票金额（含税）合计不可小于融资母票面额" +
              this.utils.splitK(this.params.info.gldAmt) +
              "元"
          );
          reject(
            "发票金额（含税）合计不可小于融资母票面额" +
              this.utils.splitK(this.params.info.gldAmt) +
              "元"
          );
        } else if (+this.params.bankChecked.applyAmt > sum) {
          this.$message.error(
            "发票金额（含税）合计不可小于本次融资金额" +
              this.utils.splitK(this.params.bankChecked.applyAmt) +
              "元"
          );
          reject(
             "发票金额（含税）合计不可小于本次融资金额" +
              this.utils.splitK(this.params.bankChecked.applyAmt) +
              "元"
          );
        }
        resolve({
          tradeBackgrounds: this.selectedRows,
          ...this.params
        });
      });
    },
    // 查看发票
    toInvoiceInfo(record) {
      this.curRow = record;
      this.$refs.invoiceInfo.open();
    },
    contractInfoOpen(data) {
      this.curRow = data;
      this.$refs.contractInfo.open();
    },
    // 相关附件上传、编辑、查看
    toDeliveryCreate(record) {
      this.$refs.relatedFileDialog.open({
        invData: record,
        dialogType: "detail"
      });
    }
  },
  created() {
    this.initData();
    this.getDicAsync("InvoiceType").then(res => {
      this.invoiceTypes = res;
    });
  },
  mounted() {},
  watch: {
    params(newVal) {
      this.initData();
    }
  }
};
</script>
<style scoped lang="less">
.left-form {
  width: 50%;
}
.img-tip {
  position: absolute;
  line-height: 16px;
  font-size: 12px;
  width: 412px;
  left: -60px;
}
/deep/ .text-color-orange.ant-btn-link {
  color: #ef763c;
}
/deep/ .ant-btn-link {
  padding: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/circulation/gold-financing/gold-financing-steps/gold-financing-step2.vue